import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component, DoCheck,
  EventEmitter, Inject,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  Output,
  SimpleChanges, ViewChild
} from "@angular/core";
import * as _ from "lodash";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {fromEvent, Subscription, throttleTime} from "rxjs";
import {
  RoutesViewSettingsServicesModel
} from "../../../../routes/models/routes-view-settings.model";
import {ServicesComponentState, ServicesComponentStore} from "../../state/services.store";
import {RoutePanelModel} from "../../../../routes/models/route-panel.model";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragEnter,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import {Service} from "../../../models/service.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {RoutesDragAndDropService} from "../../../../routes/angular/services/routes-drag-and-drop.service";

require('./services-panel-list.scss');
@Component({
  standalone: false,
  selector: 'app-services-panel-list',
  templateUrl: './services-panel-list.html',
  providers: [ServicesComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicesPanelListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() panel: RoutePanelModel;
  @Input() panels: RoutePanelModel[];
  @Input() resourcesDropListIds: string[];
  @Input() routesDropListIds: string[];
  @Input() settings: RoutesViewSettingsServicesModel;
  @Input() from?: string;
  @Input() to?: string;
  @Input() queryString?: string;
  @Input() bringozFilters?: any;
  @Input() selectedIds: string[];
  @Input() itemElementSize: string;
  @Output() onSelectServices = new EventEmitter<string[]>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onToggleVisible = new EventEmitter<boolean>();
  @Output() onRemoveTaskFromRoute = new EventEmitter<any>(); // need to connect
  @Output() onSplitByPackages = new EventEmitter<{ item: Service | TaskModel; event: MouseEvent }>();
  @Output() onDrillDown = new EventEmitter<{ routeId: string; event: any }>();

  private scrollEndTimer: any | null = null;
  @ViewChild(CdkVirtualScrollViewport) private viewport: CdkVirtualScrollViewport;

  public vm: ServicesComponentState;
  public selectedKeys: Object;
  public visibleKeys: Object;
  public allPanelIds: string[];
  public enterPredicate: (drag: CdkDrag<any>, drop: CdkDropList<any>) => boolean;

  private readonly loadLimit: number = 30;
  private vmSubscription: Subscription;
  private resizeScheduled: boolean;

  constructor(
    @Inject(ServicesComponentStore) private servicesStore: ServicesComponentStore,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject(RoutesDragAndDropService) private routesDragAndDropService: RoutesDragAndDropService) {
      this.enterPredicate = this.routesDragAndDropService.enterPredicateServices;
  }

  ngOnInit() {

    this.vmSubscription = this.servicesStore.vm$.subscribe((vm) => {
      this.vm = {...vm};
      this.viewport?.checkViewportSize();
      this.cdr.detectChanges();
    })

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.panels || changes.resourcesDropListIds || changes.routesDropListIds) {
      const drilldownLists = [];
      const filteredPanels = _.filter(this.panels, (p) => {
        if (p.id === this.panel.id) {
          return false;
        }
        if (p.selectedTabIndex === 0) {
          drilldownLists.push(`${p.id}-drilldown`);
        }
        return true;
      })
      this.allPanelIds = _.concat(_.map(filteredPanels, 'id'), this.resourcesDropListIds || [], this.routesDropListIds || [], drilldownLists);
    }
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      });
    }
    if (
      changes.queryString  ||
      changes.from ||
      changes.to ||
      changes.bringozFilters
    ) {
      this._resetStore();
      this._getServices();
    }
  }

  ngOnDestroy() {
    this.vmSubscription?.unsubscribe();
  }

  getNextBatch(event: Event) {
    if (this.viewport.measureScrollOffset('bottom') < 50 && !!this.vm.cursor && !this.vm.loading) {
      if (!!this.vm.cursor) {
        this._getServices();
      }
    }
    this.viewport.checkViewportSize();
  }

  // getNextBatch(event: Event) {
  //   if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
  //   this.scrollEndTimer = setTimeout(() => {
  //     if (this.viewport) {
  //       if (this.viewport.measureScrollOffset('bottom') < 50 && !!this.vm.cursor && !this.vm.loading) {
  //         this._getServices();
  //       }
  //       // this.viewport.checkViewportSize();
  //       window.dispatchEvent(new Event('resize'));
  //     }
  //     this.scrollEndTimer = null;
  //   }, 30);
  // }

  onToggleSelection(id, isSelected: boolean) {
    this.selectedKeys[id] = isSelected;
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });

    this.onSelectServices.emit(_.compact(selectedIds));
  }

  drop(event: CdkDragDrop<any[]>) {
    const result = this.routesDragAndDropService.onDropServices(event, this.selectedIds);
    if (result) {
      this.onRemoveTaskFromRoute.emit(result);
    }
    return false;
  }

  private _resetStore() {
    this.servicesStore.resetServices();
  }

  private _getServices() {
    this.servicesStore.getServices(this._getServicesQuery());
  }

  private _getServicesQuery() {
    const query = {
      from: this.from,
      to: this.to,
      group: this.bringozFilters.serviceStatusGroup,
      // group: this.group === 'All' ? undefined : this.group,
      serviceTypes: this.bringozFilters.serviceTypes,
      branchIds: this.bringozFilters.branchIds,
      agentBranchIds: this.bringozFilters.agentBranchIds,
      depotIds: this.bringozFilters.depotIds,
      accountIds: this.bringozFilters.accountIds,
      agentAccountIds: this.bringozFilters.supplyAccountIds,
      agentIds: this.bringozFilters.agentIds,
      teamIds: this.bringozFilters.teamIds,
      query: this.queryString,
      areaIds: this.bringozFilters.serviceAreaIds,
      beforeTimeWindow: this.bringozFilters.timeToDeliver === 'beforeTimeWindow' || undefined,
      afterTimeWindow: this.bringozFilters.timeToDeliver === 'afterTimeWindow' || undefined,
      noArea: this.bringozFilters.noArea,
      noPickUpArea: this.bringozFilters.noPickUpArea,
      noDropOffArea: this.bringozFilters.noDropOffArea,
      taskApprovalStatuses: this.bringozFilters.approvalStatuses,
      label: this.bringozFilters.labels,
      tagNames: this.bringozFilters.tags,
      vehicleTypeIds: this.bringozFilters.vehicleTypeIds,
      riskTypes: this.bringozFilters.riskTypes,
      programType: this.bringozFilters.programTypes,
      inRoute: this.bringozFilters.inRoute,
      isPacked: this.bringozFilters.isPacked,
      packingStatus: this.bringozFilters.packingStatuses,
      dispatchQuoteType: this.bringozFilters.dispatchQuoteTypes,
      missingPackageItems: this.bringozFilters.isMissingPackages,
      packageTypes: this.bringozFilters.packagesIds,
      configuredFieldId: this.bringozFilters.configuredFieldName,
      configuredFieldValue: this.bringozFilters.configuredFieldValue,
      reasonType: this.bringozFilters.reasonType,
      agentTypes: this.bringozFilters.agentType,
      limit: this.loadLimit,
      // sort: _.get(this.selectedSortValue, 'value')
    }

    Object.keys(query).forEach(key => query[key] === undefined && delete query[key]);
    return query;

  }

  public trackById(_ :number, item: Service): string {
    return item.id;
  }

}
